import utils from 'lib/utils';

const MemoryStorageService = function () {
  if (MemoryStorageService.prototype._singleton) {
    return MemoryStorageService.prototype._singleton;
  }

  MemoryStorageService.prototype._singleton = this;

  this.data = {};

  this.getItem = function (key) {
    return this.data[key];
  };

  this.setItem = function (key, value) {
    if (key === undefined) {
      throw new Error('Cannot store an item in session with an undefined key.');
    }
    this.data[key] = value;
  };

  this.removeItem = function (key) {
    return delete this.data[key];
  };

  this.clear = function () {
    return (this.data = {});
  };

  this.getByDotString = function (dotString) {
    return utils.getByDotString(dotString, this.getItem.bind(this));
  };

  this.getAll = () => this.data || {};
};

export default new MemoryStorageService();
